import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { fetchData } from "../../helpers/getData/fetchData"
import { Reservation } from "../../views/Reservation"


export const GetReservation = () => {

    const { t } = useTranslation('global')
    const { dataToAction } = useSelector(state => state.opportunity);

    const [myCompaniesList, setMyCompaniesList] = useState('isLoading')
    const [actualReservation, setActualReservation] = useState('isLoading');
    const [refetch, setRefetch] = useState(true);

    useEffect(() => {
        fetchData(setMyCompaniesList, '/companies/listName', t)
        fetchData(setActualReservation, `/reservation/actualReservation?opportunity=${dataToAction.id}`, t)
    }, [t, dataToAction.id, refetch])

    return (
        <>
            {
                (myCompaniesList !== 'isLoading' && actualReservation !== 'isLoading') &&
                <Reservation
                    myCompaniesList={myCompaniesList}
                    actualReservation={actualReservation[0]}
                    dataToAction={dataToAction}
                    setRefetch={setRefetch}
                />
            }
        </>
    )
}
